module.exports = __webpack_public_path__ + "static/media/sinister_type_robbery.89893223.svg";